/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, September 16th 2022, 1:00:52 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import type { FC } from "react";
import type { DropTargetMonitor } from "react-dnd";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import { logger } from "lib/logger";

export interface FileDropTargetProps {
  onDrop: (item: { files: File[] }) => void;
  children: (options: { isActive: boolean }) => React.ReactNode;
}

export const FileDropTarget: FC<FileDropTargetProps> = (props) => {
  const { onDrop, children } = props;
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item: { files: File[] }) {
        onDrop?.(item);
      },
      canDrop(item: any) {
        logger.debug("canDrop", item.files?.[0], item.items);
        return true;
      },
      hover(item: any) {
        logger.debug("hover", item.files, item.items);
      },
      collect: (monitor: DropTargetMonitor) => {
        const item = monitor.getItem() as any;
        if (item) {
          logger.debug("collect", item.files, item.items);
        }

        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [props]
  );

  const isActive = canDrop && isOver;
  return (
    <div ref={drop} className={isActive && "os-pulse-animation-container"}>
      {children?.({ isActive })}
    </div>
  );
};
